export enum PatientAppIframeId {
  Inline = 'inline-patient-app',
  Edit = 'edit-patient-app',
  Search = 'search-patient-app'
}